import React from 'react';
import {Helmet} from 'react-helmet-async';
import useCanonical from 'hooks/use-canonical';
import PropTypes from 'prop-types';
import useTitle from './hooks/use-title';
import useMetaDescription from './hooks/use-meta-description';
import useOpengraphTitle from './hooks/use-opengraph-title';
import useOpengraphDescription from './hooks/use-opengraph-description';
import useOpengraphImage from './hooks/use-opengraph-image';

export const ParkingTypes = Object.freeze({
    Transient: 'transient',
    Monthly: 'monthly',
    None: 'none',
});

const MarketingMetas = ({
    bodyClassNames,
    fallbackTitle,
    fallbackDescription,
    parkingType = ParkingTypes.None,
    Component = Helmet,
    isBodyRendered = true,
}) => {
    const title = useTitle(fallbackTitle, parkingType);
    const description = useMetaDescription(fallbackDescription, parkingType);
    const ogTitle = useOpengraphTitle(parkingType) || title;
    const ogDescription = useOpengraphDescription(parkingType) || description;
    const ogImage = useOpengraphImage(parkingType);
    const {canonicalURL, metaTag} = useCanonical();

    return (
        <Component>
            <title>{title}</title>
            {metaTag}
            <meta
                name="description"
                itemProp="description"
                content={description}
            />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:description" content={ogDescription} />
            {canonicalURL ? (
                <meta property="og:url" content={canonicalURL} />
            ) : null}
            {ogImage ? <meta property="og:image" content={ogImage} /> : null}
            <meta property="og:type" itemProp="og:type" content="website" />

            {/* isBodyRendered is only here to make testing easy */}
            {isBodyRendered ? (
                <body className={bodyClassNames} />
            ) : (
                <div className={bodyClassNames} />
            )}
        </Component>
    );
};

MarketingMetas.propTypes = {
    bodyClassNames: PropTypes.string,
    fallbackTitle: PropTypes.string,
    fallbackDescription: PropTypes.string,
    parkingType: PropTypes.string,
    Component: PropTypes.func,
    isBodyRendered: PropTypes.bool,
};

export default MarketingMetas;
